import { HttpHeaders } from '@angular/common/http';

export class BaseService {
    storage: Storage;

    constructor() {
        this.storage = localStorage;
    }

    protected setHeaders(): HttpHeaders {
        const headersConfig = {
            "Content-Type": "application/json",
            Accept: "application/json"
        };

        return new HttpHeaders(headersConfig);
    }

    protected setFileHeaders(): HttpHeaders {
        const headersConfig = {
            Accept: "application/json"
        };

        return new HttpHeaders(headersConfig);
    }
}
